export const headerTableDay = [
  '0〜2時',
  '2〜4時',
  '4〜6時',
  '6〜8時',
  '8〜10時',
  '10〜12時',
  '12〜14時',
  '14〜16時',
  '16〜18時',
  '18〜20時',
  '20〜22時',
  '22〜24時',
  '合計',
];

export const headerTableMonth = [
  '1月',
  '2月',
  '3月',
  '4月',
  '5月',
  '6月',
  '7月',
  '8月',
  '9月',
  '10月',
  '11月',
  '12月',
];

export const userHistoryHeader = [
  { column: 'id', label: '' },
  { column: 'companyName', label: '会社名' },
  { column: 'fullName', label: '氏名' },
  { column: 'count', label: '超過回数' },
];
